import { Spacer, VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import styled from "styled-components/native";
import currency from "currency.js";
import { DefaultThemeValueType } from "../../../../styled";
import { useUserCurrency } from "../../../hooks/getCurrency";
import React from "react";
import { ProductCategory } from "@utils/constants";
import { Response } from "@src/types/CartItemListResponse";
import { couponAdjustsPrice } from "./utils";

const TotalPriceContainer = ({
  theme,
  t,
  typography,
  userInfo,
  productType,
  cartData,
}: {
  totalPrice?: string;
  theme?: DefaultThemeValueType;
  t?: any;
  typography?: any;
  itemList?: any;
  userInfo?: any;
  productType: ProductCategory;
  cartData?: Response;
}) => {
  const userCurrency = useUserCurrency();
  return (
    <>
      {couponAdjustsPrice(cartData?.coupon) && (
        <ParentContainer>
          <Spacer size={SpaceType.Big} />
          <TextContainer>
            <VDBText color={theme["core-06"]} type={typography["Body-R"]}>
              {t("orderCart.checkout.discount.text", {
                coupon: cartData?.coupon?.coupon_code,
              })}
            </VDBText>
            <VDBText color={theme["core-05"]} type={typography["Body-M"]}>
              {"-"}
              {currency(
                cartData?.old_total_cart_price - cartData?.total_cart_price,
                {
                  symbol: userCurrency,
                  precision:
                    userInfo?.roundUpPrices() ||
                    productType === ProductCategory.JEWELRY
                      ? 0
                      : 2,
                }
              ).format()}
            </VDBText>
          </TextContainer>
        </ParentContainer>
      )}
    </>
  );
};

export default TotalPriceContainer;

const ParentContainer = styled.View`
  padding-left: ${SpaceType.Basic}px;
  padding-right: ${SpaceType.Basic}px;
`;

const TextContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
`;
